import { getApiUrl, API_ENDPOINTS } from '../config/api';
export const capabilityService = {
  async get(signal) {
    const response = await fetch(getApiUrl(API_ENDPOINTS.portfolio.capabilities), {
      signal, credentials: 'omit', cache: 'no-store',
    });
    if (!response.ok) throw new Error('Capabilities unavailable');
    return response.json();
  },
};
export function validateCapabilities(data) {
  const valid = data?.contractVersion === 1 &&
    typeof data?.capabilities?.inlineAnswers?.enabled === 'boolean' &&
    typeof data?.capabilities?.extendedChat?.enabled === 'boolean' &&
    typeof data.contentRevision === 'string';
  return {
    inlineAnswers: valid && data.capabilities.inlineAnswers.enabled === true,
    extendedChat: valid && data.capabilities.extendedChat.enabled === true,
    contentRevision: valid ? data.contentRevision : null,
  };
}
